const getRiskData = async (effective_date=null) => {

    const insert_data = {};

    if (effective_date) {
        //if you want to grab the risk for a specific date. Else, grabs the most recent
        insert_data['effective_date'] = effective_date;
    } else {
        insert_data['current'] = 'true';
    }

    try {
        const host = window.location.host === "xchge.nysmesonet.org" || window.location.host.split(":")[0] === "localhost";
        const url = host ? 'https://api.nysmesonet.org/data/firewx/GetFDRA/index.php': 'https://api.nysmesonet.org/data/firewx/GetFDRA/index.php';        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(insert_data)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return(result);

    } catch (error) {
        console.error('Error updating data:', error);
    }
}



export {getRiskData};